import React from 'react'
import { Link } from 'react-router-dom'
import includes from 'lodash/includes'

const MenuItem = ({ menu, location, role, branch }) => {
  return (
    <li
      style={{
        display: (menu.hidden)
          ? 'none'
          : 'inherit'
      }}
      className={`/${location.pathname.split('/')[1] === menu.url ? 'active' : ''} ${menu.subs ? 'open' : ''}`}>
      {
        menu.subs
          ? <a role='button'>{menu.title}<i className='fa arrow' /></a>
          : <Link to={menu.url || '/#'}> {menu.title} </Link>
      }
      {
        menu.subs &&
        <ul className='sidebar-nav'>
          {
            menu.subs.map((child, i) => {
              if ((includes(child.role, role) && (includes(child.branch, branch)))) {
                return (
                  <li key={i} className={location.pathname === child.url ? 'active' : ''}>
                    <Link to={child.url}> {child.title} </Link>
                  </li>
                )
              } else {
                return null
              }
            })
          }
        </ul>
      }
    </li>
  )
}

export default MenuItem



// WEBPACK FOOTER //
// ./src/Components/Nav/MenuItem.js